import { GatewaysAuthPage } from "./gateways/GatewaysAuth";

export const ExternalGatewayPage = GatewaysAuthPage;
